import React, { useRef, useEffect, useCallback, useState} from 'react';
import {getLogScale} from 'components/effects/SpectrumUtils.js';
import {useInterval} from "components/hooks/useInterval.js"
import {connect} from 'react-redux';

const FormantsAnalyzer = ({oscillator, width, height}) => { 

    let ref = useRef();
    let context = useRef();

    useEffect(() => {
        context.current = ref.current.getContext("2d");
    }, []);

    let [rects, setRects] = useState([]);
    const callback = useCallback(() => {
        let pts = [];
        let list = Array.from( oscillator.formantsManager.analyser.getValue());
        let totalWidth = 0;
        for (let i=0; i < list.length; i++) {
            let value = list[i];
            let _height = getLogScale(value, -160, 0, 1, height);
            //console.log("height for i=%s height=%s", i, height, value)

            let freq = i*44100/256;;
            let nextFreq = (i+1)*44100/246;
            let x =  Math.pow(freq/44100, 0.5) * width;
            let nextX = Math.pow(nextFreq/44100, 0.5) * width;
            let _width = nextX - x;
            if (x < width) {
                pts.push({x: x, y: height-_height, width: _width, height: _height});
            }
        }
        setRects(pts);
    }, [setRects, width, height, oscillator]);

    useEffect(() => {
        if (context.current) {
            window.requestAnimationFrame(draw);
        }
    }, [rects, width, height]);

    const draw = useCallback(() => {
        let ctxt = context.current;
        if (!ctxt || !ref.current) {
            return;
        }
        ctxt.clearRect(0,0,ref.current.width,ref.current.height);
        for (let {x,y,width,height} of rects) {
            ctxt.beginPath()
            ctxt.rect(x,y,width,height);
            ctxt.fillStyle = '#383838';
            ctxt.fill();
        }
    }, [rects, width, height]);

    useInterval(callback, 100);
    return (
        <canvas className="formant-analyser" ref={ref} width={width} height={height} style={{width, height}}>
        </canvas>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormantsAnalyzer);
